<template lang="html">

    <article class="oferta-el -listado">

        <div class="top row-between aifs">

            <div>
                <h3 title="Empresa" class="empresa">{{data.empresa}}</h3>
                <h3 title="Sector" class="categoria -sector" v-if="!!data.sectorEmpresa">{{data.sectorEmpresa}}</h3>
                <h3 class="categoria" v-if="!!data.curricular">Práctica
                    curricular</h3>
                <h3 class="categoria" v-if="!!data.esInternacional">Práctica
                    internacional</h3>
            </div>


            <div class="tips row-end">
                <h3 class="fecha">{{data.fecha}}</h3>
                <h3 class="localizacion" v-if="!!data.provincia || !!data.localidad || !!data.pais">
                    {{data.provincia}}<template v-if="!!!data.provincia & !!data.localidad">{{data.localidad}}</template><template v-if="!!data.pais">, {{data.pais}}</template>
                </h3>
            </div>

        </div>

        <div class="middle row-between">
            <h2 class="titulo">{{data.titulo}}</h2>
        </div>

        <div class="descripcion" v-if="data.descripcion.includes('<p>')"
            v-html="data.descripcion"></div>
        <div class="descripcion" v-else>
            <p v-html="data.descripcion"></p>
        </div>

        <router-link class="enlace-cover" v-if="!!data.esProgramaIndependiente"
            :to="$t('enlaces.programaindependiente')+'/'+data.urlAcceso"></router-link>
        <router-link class="enlace-cover" v-else
            :to="$t('enlaces.oferta')+'/'+data.urlAcceso"></router-link>
    </article>


</template>

<script lang="js">
    export default {
        name: 'oferta-el',
        props : ['data']

    }
</script>

<style scoped>
    .categoria{
        margin-left: 0;
        }

        .oferta-el .top .tips .fecha{
            margin-right: 0;
            margin-bottom: 0;
        }

        .oferta-el.-listado .tips{
            width: 50%;
            flex-direction: column;
            align-items: flex-end;
        }

        .oferta-el.-listado .top > div {
            width: 50%;
            flex-direction: column;
            align-items: flex-end;
        }


        @media screen and (max-width: 900px){
            
        .oferta-el.-listado .tips{
            width: 100%;
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 5px;
        }

        .oferta-el.-listado .top > div {
            width: 100%;
            flex-direction: column;
            align-items: flex-start;
        }
        }
</style>


// WEBPACK FOOTER //
// src/components/view-parts/home/oferta-el.vue